import reduxMount from './../../jsCore/utils/reduxMounter'
import { MOUNT_POINTS } from './../../jsCore/config/preRenderedSelectorsConfig'
import { AdminPanelContainer } from './AdminPanel.container'

const COMPONENT_NAME = 'adminPanel'
const STATE_KEY = 'adminPanel'

export const init = () =>
  reduxMount({
    [MOUNT_POINTS.ADMIN_PANEL]: AdminPanelContainer({
      componentName: COMPONENT_NAME,
      stateKey: STATE_KEY,
    }),
  })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/admin_panel/index.js